var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDroneCardIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7087 27.0553V26.3373C43.7087 24.8527 44.6953 23.5422 46.1144 23.1261V20.1283H41.5796C40.3288 20.1283 40.3288 18.2373 41.5796 18.2373H46.1144V17.1931C46.1144 15.9565 47.9954 15.9565 47.9954 17.1931V18.2373H52.5302C53.781 18.2373 53.781 20.1283 52.5302 20.1283H47.9954V23.1261C49.4139 23.5428 50.4016 24.8516 50.4016 26.3373V29.6925C50.4016 31.2617 49.5573 32.2724 48.4683 32.7269C48.1006 32.9263 47.6369 33.0422 47.0686 33.0422H43.5561V36.9569C43.5561 38.6965 42.5398 40.2102 41.0718 40.9331C42.4579 42.8608 42.7976 44.0651 42.7976 47.6348H40.0032C40.0032 43.9999 39.6765 43.5287 37.9728 41.3854H26.5117C24.808 43.5287 24.4807 43.9999 24.4807 47.6348H21.6869C21.6869 44.0656 22.0265 42.8603 23.4127 40.9331C21.944 40.2102 20.9278 38.6965 20.9278 36.9569V33.0422H17.4147C16.8465 33.0422 16.3823 32.9263 16.014 32.7263C14.926 32.2719 14.0823 31.2606 14.0823 29.6925V26.3373C14.0823 24.8516 15.07 23.5428 16.4885 23.1261V20.1283H11.9537C10.7029 20.1283 10.7029 18.2373 11.9537 18.2373H16.4885V17.1931C16.4885 15.9565 18.3695 15.9565 18.3695 17.1931V18.2373H22.9043C24.1551 18.2373 24.1551 20.1283 22.9043 20.1283H18.3695V23.1261C19.7886 23.5422 20.7757 24.8527 20.7757 26.3373V27.0559L43.7087 27.0553ZM32.2422 31.452C33.4283 31.452 34.3896 32.4131 34.3896 33.5991C34.3896 34.785 33.4283 35.7462 32.2422 35.7462C31.0561 35.7462 30.0948 34.785 30.0948 33.5991C30.0948 32.4131 31.0561 31.452 32.2422 31.452Z",
    fill: "#0F5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroneCardIconActive);
export default __webpack_public_path__ + "static/media/droneCardIconActive.767a29790f644f002b82b75d244c6c82.svg";
export { ForwardRef as ReactComponent };